export enum ImportTypeEnum {
    UNKNOWN = 'UNKNOWN',
    CREATE_NEW_LISTING = 'CREATE_NEW_LISTING',
    OVERWRITE_LISTING = 'OVERWRITE_LISTING',
}
